import { AmenityKindEnum } from "redmond/apis/tysons/vacation-rentals";

export const PREMIUM_AMENITIES: AmenityKindEnum[] = [
  AmenityKindEnum.FitnessCenter,
  AmenityKindEnum.Pool,
  AmenityKindEnum.BeachFront,
  AmenityKindEnum.HotTub,
  AmenityKindEnum.Housekeeping,
  AmenityKindEnum.MountainView,
  AmenityKindEnum.Gym,
  AmenityKindEnum.Waterfront,
  AmenityKindEnum.GardenOrBackyard,
  AmenityKindEnum.Fireplace,
  AmenityKindEnum.FirePit,
  AmenityKindEnum.PoolTable,
  AmenityKindEnum.Sauna,
  AmenityKindEnum.SkiInSkiOut,
  AmenityKindEnum.OnDemandHousekeeping,
  AmenityKindEnum.FrontDesk,
];

export const VR_NOT_AVAILABLE_MODAL_TITLE =
  "This vacation rental is not available.";

export const RETURN_TO_SEARCH_MODAL_SECONDARY_TEXT =
  "Return to the search page for more vacation rentals.";

export const RETURN_TO_SEARCH_MODAL_PRIMARY_BUTTON_TEXT = "Return to search";

export const VETTED_TITLE = "Vetted for quality";

export const VETTED_TEXT =
  "Each property in the Premier and Lifestyle Collection is vetted for quality and selected based on exceptional design, premium amenities and elevated service standards.";

export const PREMIUM_AMENITIES_TITLE = "Premium amenities";

export const ROOMS_AND_BED_TITLE = "Rooms and beds";

export const IMPORTANT_INFORMATION_TITLE = "Important information";

export const AMENITIES_TITLE = "Amenities and features";

export const LOCATION_TITLE = "Location";

export const REVIEWS_TITLE = "Customer reviews";
